import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, Subject } from 'rxjs';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import * as moment from 'moment';
import { CheckoutDialogComponent } from '../checkout-dialog/checkout-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { map } from 'rxjs/operators';
import { HistoryDialogComponent } from '../history-dialog/history-dialog.component';
import { TokenService } from 'src/services/token.service';

export interface PaymentHistory {
  charge_id: number;
  status: string;
  created_at: string;
  expire_at?: string;
}

// Exemplo de estrutura de plano
interface Plan {
  name: string;
  price: string;
} 

@Component({
  selector: 'app-my-account-company',
  templateUrl: './my-account-company.component.html',
  styleUrls: ['./my-account-company.component.scss']
})
export class MyAccountCompanyComponent implements OnInit {

  historic:boolean = false;
  cancel:boolean = false;
  submiting: boolean = false;
  user: any;
  trialDate: any;
  listPayments: Array<any>;
  listPaymentsIndex: number = -1;
  detailsPayment: any;
  displayedColumns: string[] = ['bank', 'charge_id', 'payment_type', 'created_at', 'expire_at', 'status', 'download'];
  dataSource = new MatTableDataSource<PaymentHistory>([]);
  intervalId : any;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private http: HttpService,
    private snackbar: MatSnackBar,
    private errorReport: ErrorReportService,
    private dialog: MatDialog,
    private token : TokenService

  ) { }

  ngOnInit(): void {

    this.user = JSON.parse(localStorage.getItem('token'));    
    let subject = new Subject();

    subject.subscribe(
      (result: any) => {

        const { trigger, scope } = result;        
        if(scope.indexOf('gerencianet') > -1)
          this.submiting = trigger === 'pre';
        
      }
    );

    this.http.setLoadingIndicator(subject);
    //this.trialDate = this.user.signature_date;
    this.getSignature();

    this.dataSource.paginator = this.paginator;

    this.getProcessList(); 
    this.countDaysTrial();  

    this.startHourlyTask();

  }

  ngOnDestroy(): void {
    this.clearHourlyTask();
  }

  startHourlyTask(): void {
    // Executa a função a cada 1 hora (3600000 milissegundos)
    this.intervalId = setInterval(() => {
      this.token.atualizar();
      setTimeout(()=>{
        this.user = JSON.parse(localStorage.getItem('token'));
        this.cancel = false;
    },1000);
    }, 20000);
  }

  clearHourlyTask(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  // isTrial() {
  //   const now = moment();
  //   return this.trialDate ? now.isSameOrBefore(this.trialDate) : null;
  // }

  countDaysTrial(){
    this.http.get('company:count_days_trial', { id: this.user.company_id })
      .subscribe(
        (result: any) => {
          //console.log(result.data);
          this.trialDate = result.data;
        },
        err => this.errorReport.showMessage(err)
      )
  }

  getProcessList() {

    this.http.get('payment_list', { company: this.user.id })
      .subscribe(
        (result: any) => {
          // console.log(result);
          this.listPayments = result.data;
        },
        err => this.errorReport.showMessage(err)
      )

  }

  cancelSignature() {

    if(!confirm('Deseja realmente cancelar sua assinatura do plano atual'))
      return;

    this.cancel = true;

    const params = {
      id: this.user.company_id
    }
    this.http.delete('gerencianet:cancel', params)
      .subscribe(
        (result: any) => {

          if(result.type === 'OK') {
            this.snackbar.open('Cancelamento feito com sucesso, acesse sua conta novamente para validação', 'OK', { duration: 3000 })
              .afterDismissed()
              .subscribe(
                () => {
                  this.user.signature_status = null;
                  this.user.signature_id = null;
                  localStorage.setItem('token', JSON.stringify(this.user)) ;
                  // localStorage.clear();
                  window.location.reload();
                }
              );
            
          } else this.snackbar.open('Não foi possivel cancelar no momento tente novamente mais tarde!', 'OK', { duration: 3000 });
          
        },
        err => this.errorReport.showMessage(err)
      )


  }

  openCheckout() {
    var plano = this.user.company_id ? 'BUSINESS' : 'PERSONAL';
    if(plano == 'BUSINESS' && this.user.signature_status !== 'ACTIVE' && this.user.signature_status !== 'TRIAL'){
      const options = {
        disableClose: true,
        width: '1000px',
        data: { paymentMethod: 'CREDIT_CARD' }
      }
      this.dialog.open(CheckoutDialogComponent, options)
    }else{
      alert('Você está no plano gratuito');
    }

  }

  getSignature() {    
    this.http.save('gerencianet:details_payment', { id: this.user.signature_id })
      .subscribe(
        (result: any) => {
          if (result.type === 'OK') {
            this.detailsPayment = result.data; 
            if(this.detailsPayment){
              this.historic = true;
            }   

            // Para armazenar as informações das cobranças
            const chargeRequests = this.detailsPayment.data.history.map((item: any) => 
              this.getCharge(item.charge_id).toPromise()
            );
            
            Promise.all(chargeRequests)
              .then(chargeResponses => {
                // Atualizar os dados da tabela com as informações de vencimento
                this.dataSource.data = this.detailsPayment.data.history.map((item: any, index: number) => {
                  const chargeResponse = chargeResponses[index];
                  const expireAt = chargeResponse?.data?.payment?.banking_billet?.expire_at || null;
                  const pdf = chargeResponse?.data?.payment?.banking_billet?.link || null;
                  return {
                    ...item,
                    expire_at:expireAt,
                    pdf,
                    history: chargeResponse?.data?.history || []
                  };
                });
                this.dataSource._updateChangeSubscription();
                this.dataSource.sort = this.sort;
              })
              .catch(err => this.errorReport.showMessage(err));
            
          } else {
            //this.snackbar.open('Ocorreu um erro, tente novamente mais tarde!', 'OK', { duration: 3000 });
          }
        },
        err => this.errorReport.showMessage(err)
      )
  }

  getCharge(id: string): Observable<any> {
    return this.http.save('gerencianet:details_charge', { id })
      .pipe(
        map((result: any) => {
          if (result.type === 'OK') {
            return result.data;
          } else {
            throw new Error('Failed to fetch charge details');
          }
        })
      );
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  translateStatus(status: string): string {
    const statusMap: { [key: string]: string } = {
      'new': 'novo',
      'waiting': 'aguardando',
      'identified': 'identificado',
      'approved': 'aprovado',
      'paid': 'pago',
      'unpaid': 'não pago',
      'refunded': 'devolvido',
      'contested': 'contestado',
      'canceled': 'cancelado',
      'settled': 'marcar como pago',
      'expired': 'expirado'
    };
  
    return statusMap[status] || status; // Retorna o status traduzido ou o original se não encontrar correspondência
  }

  formatDate(date: string): string {
    return moment(date).format('DD/MM/YYYY');
  }

  getStatusClass(status: string): string {
    const statusClasses = {
      'new': 'status-new',
      'waiting': 'status-waiting',
      'identified': 'status-identified',
      'approved': 'status-approved',
      'paid': 'status-paid',
      'unpaid': 'status-unpaid',
      'refunded': 'status-refunded',
      'contested': 'status-contested',
      'canceled': 'status-canceled',
      'settled': 'status-settled',
      'expired': 'status-expired',
    };
    return statusClasses[status] || 'status-default'; // Optional default class
  }

  openHistoryDialog(history: any[]) {
    const dialogRef = this.dialog.open(HistoryDialogComponent, {
      width: '600px',
      data: { history }
    });
  
    dialogRef.afterClosed().subscribe(result => {
      console.log('Dialog fechado', result);
    });
  }


getPlanDetails(): Plan {
  switch (this.user.signature_plan_id) {
    case 'YEARLY_BUSINESS':
      return { name: 'Anual', price: 'R$ 5.058,91' };
    case 'SIXMONTHLY_BUSINESS':
      return { name: 'Semestral', price: 'R$ 2.687,54' };
    case 'TREEMONTHLY_BUSINESS':
      return { name: 'Trimestral', price: 'R$ 1.422,81' };
    case 'TREEMONTHLY_BUSINESS_PLUS':
      return { name: 'Trimestral', price: 'R$ 1.287,69' };
    case 'MONTHLY_BUSINESS':
      return { name: 'Mensal', price: 'R$ 526,97' };
    default:
      return { name: 'Desconhecido', price: 'N/A' };
  }
}

openPdf(pdfUrl: string) {
  if (pdfUrl) {
    window.open(pdfUrl, '_blank');
  }
}

}
